import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
import NotesTrailDropdown from "./NotesTrailDropdown";
import ConfirmationModal from "./ConfirmationModal";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Select from "react-select";
import api from "../../../utils/api";
import { useState } from "react";
import CentralizedNotesModal from "../Handholder/CentralizedNotesModal";
import CentralizedSMSLogModal from "../Handholder/CentralizedSMSLogModel";
import ESPSMSTrail from "../../../containers/EServicePartnerServiceRequests/ESPSMSTrail";
//import ColumnSectionDropdown from "../Admin/ColumnSelectionDropdown";
import StatusSelectionDropDown from "../Admin/StatusSelectionDropDown";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import { ControlledInput } from "../../../common/Input/Input";


export default function ServiceStatusModal(props){

	// const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	// const toggleViewAllNotesModal = () => {
	// 	setShowViewAllNotesModal(!showViewAllNotesModal);
	// };

	// const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	// const toggleViewAllSMSModal = () => {
	// 	setShowViewAllSMSModal(!showViewAllSMSModal);
	// };

	return (
		<Modal 
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
			className="conv-mdl-wd"
		>
			<ModalContent>

            <div className="p-2 modal-headers-barss">
					<span style={{color:"black",fontWeight:"bold",marginLeft:"5%"}}>Service Status</span>
					<button
						type="button"
						className="close conv-mr15"
						aria-label="Close"
						onClick={() => props.toggleModal(!props.isOpen)}
					>
						<X
							style={{ pointerEvents: "none"}}
							color="black"
						/>
					</button>
				</div>
				 
			  <div style={{width:"314px",marginLeft:"20px",marginTop:"20px"}}>
                        {/* <div className=".btns-searchs-by con-cursor-pointer"
                            onClick={()=>{
                                props.togglesSearchsByVisibilitys();
                            }}
                        >
							<div className="">
                            <span className="spans-texts-searchs-by">
                                Select Status
                            </span>
                            <img
                                alt=""
                                src={select_arrow_down}
                                height={"12px"}
                                width={"12px"}
                                className="conv-ml10"
                            /> 
                            </div>
							</div>
                            {
                            props.isSearchByStatusDropdownOpen &&
                            <div className="spms-searches-by" ref={props.SearchsDropdownRefs}>
                                <StatusSelectionDropDown
                                    isOpen={props.isSearchByStatusDropdownOpen}
                                    toggleSelection={props.selectSearchStatusBySelection}
                                    checkboxItemsList={props.SearchsByDropdownLists}		
									value = {props.selectedOptions}						
                                />
                            </div> */}
					   		 {/* }	 */}

						<Select 
                            styles={{
                                // Fixes the overlapping problem of the component
                                menu: provided => ({ ...provided, zIndex: 3 })
                            }}
                            placeholder="Select Status"
                            options={props.SearchsByDropdownLists}
                            onChange={props.onStatusOptionChange}
                            value={props.selectedOptions}
							isDisabled={props.selectedServiceRequestForStatusProgression&&props.selectedServiceRequestForStatusProgression.refService.refCurrentState.sServiceState=="Cancelled"}
                            className='react-select-container'
                            classNamePrefix="react-select"
                            theme={theme => ({
                                ...theme,
                                colors: {
                                ...theme.colors,
                                primary: '#76287C',
                                primary25: '#F4DFF4',
                                },
                            })}
                        ></Select>

                    </div>


					{
						props.selectedOptions.value=="Cancelled"?(
							<div className="col-12 conv-pl20 conv-pr20">

							<label className="my-services-model-value">Cancellation Reason:</label>
							<Select
								styles={{
									// Fixes the overlapping problem of the component
									menu: provided => ({ ...provided, zIndex: 3 })
								}}
								className='react-select-container'
								classNamePrefix="react-select"
								theme={theme => ({
									...theme,
									colors: {
										...theme.colors,
										primary: '#76287C',
										primary25: '#F4DFF4',
									},
									})}
								options={props.cancellationReasonDropdownOptions}
								onChange={props.onSelectCancellationReason}
								value={props.selectedCancellationReason}
								isDisabled={props.selectedServiceRequestForStatusProgression&&props.selectedServiceRequestForStatusProgression.refService.refCurrentState.sServiceState=="Cancelled"}
								isClearable
							/>
						</div>
						):("")

					}

						{
							props.enableOtherDescriptionTextbox ? 
							(
								<div className={`col-12 conv-mt25 conv-pl20 conv-pr20 ${props.selectedServiceRequestForStatusProgression&&props.selectedServiceRequestForStatusProgression.refService.refCurrentState.sServiceState=="Cancelled"?"disable":""}`}>
									<label className="my-services-model-value">Other Cancellation Reason:</label>
									<ControlledInput
										placeholder="Please specify a reason here"
										// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
										onChange={({ target }) =>
											props.onChangeCancellationReasonOtherDescription(
												target.value
											)
										}
										value={props.cancellationReasonOtherDescription}
									/>
								</div>
							) : ("")
						}




					<div className="flex auditss-bodys">
						 	 
							<button
								type="button" 
								className="spms-cons-btns-bordered-filter conv-mr40 conv-ml30 assgn-width"
								onClick={props.toggleModal}
							>
								Cancel
							</button>
							 

							{/* <Button onClick={props.onSaveNotesDetails}>
								Save
							</Button> */}
							 
							<button className={`lpms-cons-btns-filled conv-mr40 assgn-width ${props.selectedServiceRequestForStatusProgression&&props.selectedServiceRequestForStatusProgression.refService.refCurrentState.sServiceState=="Cancelled"?"disable":""}`}
                            onClick={props.changeState} >
                            Save
                        	</button>			
						 
					</div>

						<ConfirmationModal
							message={props.message}
							isOpen={props.isOpenConfirmation}
							toggleModal={props.toggleConfirmationModal}
							changeState={props.changeState}
						/>





			</ModalContent>
		</Modal>
	);
}
